import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useSessionStatus } from "../hooks/useSessionStatus";
import SessionLoader from "../components/Common/SessionLoader";
import {
  clearLocalSession,
  SESSION_CHECKING,
  SESSION_VALID,
} from "../helpers/sessionValidation";

const PublicProtected = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  const exceptions = [
    "/logout",
    "/change-password-new",
    "/change-password-unblocked"
  ];

  // Flux de reinitialisation via lien email (ex: newMailUnlockedAccount.html)
  // Route publique : /forgetPass/:username/:urlId/:language -> ReinisializePassword
  const isResetFlow = location.pathname
    .toLowerCase()
    .startsWith("/forgetpass");

  // Securite : si un token residuel traine dans le navigateur, on le retire
  // pendant le flux de reinitialisation pour qu'aucun autre garde / intercepteur
  // 401 ne puisse renvoyer vers /login. Le lien email doit toujours ouvrir
  // directement la page de reinitialisation, des le premier clic.
  useEffect(() => {
    if (isResetFlow && token) {
      localStorage.removeItem("token");
    }
  }, [isResetFlow, token]);

  // Etat de la session (une seule verification serveur partagee avec
  // AuthProtected). Empeche de renvoyer vers /home avec un token expire,
  // ce qui provoquait l'affichage fugitif de la plateforme puis un retour
  // vers /login.
  const sessionStatus = useSessionStatus();

  // Le flux de reinitialisation passe toujours, sans aucune redirection.
  if (isResetFlow) {
    return children;
  }

  // Changement de mot de passe obligatoire non termine : l'utilisateur ne doit
  // pas pouvoir revenir sur /login (puis /home) via le bouton "Precedent".
  // On le deconnecte et on le laisse sur /login, sauf s'il est sur la page de
  // changement de mot de passe elle-meme (exceptions).
  const mustChangePassword =
    localStorage.getItem("passwordChange") === "true";

  if (token && mustChangePassword && !exceptions.includes(location.pathname)) {
    clearLocalSession();
    return <Navigate to="/login" replace />;
  }

  if (token && !exceptions.includes(location.pathname)) {
    // Validation de la session en cours : ecran neutre, on n'affiche ni la
    // page de login ni la plateforme tant que le resultat est inconnu.
    if (sessionStatus === SESSION_CHECKING) {
      return <SessionLoader />;
    }

    // Session confirmee valide : l'utilisateur est deja connecte.
    if (sessionStatus === SESSION_VALID) {
      return <Navigate to="/home" replace />;
    }

    // Session expiree : le token a ete nettoye, on affiche la page publique
    // (login) sans redirection intermediaire.
  }

  return children;
};

export default PublicProtected;
